import { Paper, Typography, Box } from '@mui/material';
import FormSection from '@shared/components/FormSection';

const EnteredDataSection = ({ title = 'Datos Ingresados', fieldsList }) => {
  if (!fieldsList || fieldsList.length === 0) return null;

  return (
    <FormSection title={title}>
      {fieldsList.map((fields, index) => (
        <Paper
          key={`entered-data-paper-${+index}`}
          elevation={1}
          sx={{
            p: 2,
            borderRadius: 2,
            border: '1px solid #f5f5f5',
            backgroundColor: '#fcfcfc',
          }}
        >
          {Object.entries(fields).map(([key, value]) => (
            <Box key={key} display="flex" gap={1} mb={0.5} flexWrap="wrap">
              <Typography
                sx={{
                  fontWeight: 600,
                  color: '#000',
                  fontSize: { xs: '15px', md: '16px' },
                  wordBreak: 'break-word',
                }}
              >
                {key}:
              </Typography>
              <Typography
                sx={{
                  color: '#000',
                  fontSize: { xs: '15px', md: '16px' },
                  wordBreak: 'break-word',
                }}
              >
                {value}
              </Typography>
            </Box>
          ))}
        </Paper>
      ))}
    </FormSection>
  );
};

export default EnteredDataSection;
